module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section01_02_american-village-35d421043fa17565f4dc196ef3ac3d0e.jpg";